"use client"

import React, { createContext, useContext } from 'react'
import { useIsDesktop } from '@/hooks/app/useIsDesktop'

// Create a context for mobile detection
const MobileContext = createContext<boolean>(false)

// Custom hook to use the mobile context
export function useMobileContext() {
  return useContext(MobileContext)
}

// Provider component that uses the useIsDesktop hook to provide the mobile status
export function MobileProvider({ children }: { children: React.ReactNode }) {
  const isDesktop = useIsDesktop()
  
  // If not desktop, then it's mobile
  const isMobile = !isDesktop
  
  return (
    <MobileContext.Provider value={isMobile}>
      {children}
    </MobileContext.Provider>
  )
}